import { render, staticRenderFns } from "./FormWeightUnits.vue?vue&type=template&id=1709c244&"
import script from "./FormWeightUnits.vue?vue&type=script&lang=js&"
export * from "./FormWeightUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports